import { matchPath, useLocation } from 'react-router-dom'
import { spacePath } from '../App'

type spaceParams = { eventSlug: string, type: string, spaceSlug: string }

export default (): spaceParams => {
    const location = useLocation()
    const match = matchPath(location.pathname, {
        path: spacePath,
        exact: false,
        strict: false
    })
    return match.params as spaceParams
}
